export default {
  precos: [],
};
